// IE
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// IE SAGA
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'components/App';
import storeConfigure from 'reducer/storeConfigure';
import 'css/style.css';
import 'i18n';

const store = storeConfigure()

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// reportWebVitals();
